import React from 'react';
import { Page, BText } from '../../../components';
import { Input, Button, FormContainer, FieldGroupContainer, ButtonContainer } from '../../../components/Form';
import { themeForm } from '../../../styles';

export const DemoForm = () => {
  return (
    <Page title={'Demo - Form'}>
      <FormContainer title="My Profile" style={[themeForm.center]}>
        <Input value="" id="name" label="Name" />
        <Input type="number" value="" id="age" label="Age" />
        <Input type="date" value="" id="date" label="DOB" />
        <FieldGroupContainer title="Password" readonly={true}>
          <Input type="password" value="" id="date" label="Password" />
          <Input type="password" value="" id="date" label="" placeholder="Confirm password" />
        </FieldGroupContainer>
        <Input type="email" value="" id="email" label="Email" />
        <Input
          type="select"
          value=""
          id="State"
          label="State"
          dataSource={[
            { label: 'Johor', value: 'JRH' },
            { label: 'Pahang', value: 'PHG' },
          ]}
        />
        <BText>Vertical Style</BText>
        <ButtonContainer direction="vertical">
          <Button onPress={() => console.log('OK')}>OK</Button>
          <Button onPress={() => console.log('Cancel')} colorName="grey">
            Cancel
          </Button>
          <Button onPress={() => console.log('Disabled')} disabled>
            Disabled
          </Button>
        </ButtonContainer>

        <BText>Horizontal style</BText>
        <ButtonContainer direction="horizontal">
          <Button onPress={() => console.log('OK')}>OK (Warning)</Button>
          <Button onPress={() => console.log('Cancel')} colorName="grey">
            Cancel
          </Button>
        </ButtonContainer>

        <BText>Single button, use vertical</BText>
        <ButtonContainer direction="vertical">
          <Button onPress={() => console.log('OK')}>OK</Button>
        </ButtonContainer>
      </FormContainer>
    </Page>
  );
};
